module.exports = __webpack_public_path__ + "img/nav7.04591761.png";